export default "__VITE_ASSET__CbW1nuZb__"